import { Location as BGPosition } from '@capacitor-community/background-geolocation'
import { BGWatcherIDString, GeolocationAdapterReturn } from '../types/adapters'
import { computed, ComputedRef, ref } from 'vue'
import { selectGeolocationAdapter } from '../adapters/selectGeolocationAdapter'
import { logInfo } from '../utils'

type WatcherData = BGPosition[]
const watcherData = ref<WatcherData>([])
const activeWatcherID = ref<BGWatcherIDString>('')

type UseBackgroundGeolocationReturn = Omit<GeolocationAdapterReturn, 'addWatcher'> & {
  addWatcher: () => void
  removeWatcher: () => void
  getWatcherData: ComputedRef<WatcherData>
  getActiveWatcherID: ComputedRef<BGWatcherIDString>
}
export function useBackgroundGeolocation(): UseBackgroundGeolocationReturn {
  const adapter = selectGeolocationAdapter()
  const getWatcherData = computed(() => {
    return watcherData.value
  })
  const clearWatcherData = () => {
    watcherData.value = []
  }

  const getActiveWatcherID = computed(() => {
    return activeWatcherID.value
  })
  const setActiveWatcherID = (watcherID: BGWatcherIDString) => {
    // Current implementation only one active watcher ID
    if (typeof watcherID === 'string') {
      activeWatcherID.value = watcherID
    }
  }
  // Watcher removed immediately, only returns one location.
  const getGPSPosition = async (timeout?: number, useStaleData?: boolean) => {
    const data = await adapter
      .getGPSPosition(timeout, useStaleData)
      .then((gps) => {
        return gps
      })
      .catch((error) => {
        logInfo('error', 'getGPSPosition', 'Error fetching GPS Position', { error })
      })
    return data
  }
  const addWatcher = () => {
    adapter.addWatcher(extractLocations, extractWatcherID)
  }
  const removeWatcher = () => {
    adapter.removeWatcher(getActiveWatcherID.value)
    clearWatcherData()
    activeWatcherID.value = ''
  }
  const extractLocations = (position: BGPosition) => {
    watcherData.value.push(position)
  }
  const extractWatcherID = (watcherID: BGWatcherIDString) => {
    setActiveWatcherID(watcherID)
  }

  return { getGPSPosition, addWatcher, removeWatcher, getWatcherData, getActiveWatcherID }
}
